import thunk from './thunk-with-logout-middleware';
import {createStore, applyMiddleware, compose} from 'redux';
import reducers, {InitialState} from './';

// call this action automatically when a 401 status is received in async actions

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
//const createStoreWithMiddleware = applyMiddleware( asyncMiddleware )(createStore);

const store = createStore(
    reducers,
    InitialState,
    composeEnhancers(applyMiddleware(thunk)));


export default store;


// WEBPACK FOOTER //
// ./src/model/reducers/store.js